<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
      this.$showMsg(this.$t("NOT_FOUND"), 'info');
      this.$router.push("/");
  }
}
</script>